// extracted by mini-css-extract-plugin
export default {"textInput":"textInput_textInput__QlYJv"};